import React from 'react';

import { useStoreContext } from 'features/store';

import { IBringgUuids } from '@rbi-ctg/frontend';
import { IServerOrder } from '@rbi-ctg/menu';

import useOrderConfirmationMap from './use-order-confirmation-map';

interface IOrderConfirmationMapProps {
  bringgUuids?: IBringgUuids;
  serverOrder: IServerOrder;
}

const Map: React.FC<React.PropsWithChildren<IOrderConfirmationMapProps>> = ({
  bringgUuids = {},
  serverOrder,
}) => {
  const { store } = useStoreContext();

  const map = useOrderConfirmationMap({
    serverOrder,
    store,
  });

  return <>{map}</>;
};

export default Map;
